module.exports = __webpack_public_path__ + "d404f3aa7fa02daef817c414a9974078.png";